<template>
  <a-modal
    :title="title"
    :width="1007"
    :centered="true"
    :visible="visible"
    :destroyOnClose="true"
    :okText="$t('disp.btn.close')"
    @ok="handleCancel"
    @cancel="handleCancel"
    wrapClassName="history-modal-wrapper"
  >
    <!-- タイムライン -->
    <div class="history-wrapper timeline">
      <a-timeline v-if="actionHistoryVo && actionHistoryVo.length > 0">
        <div v-for="actionVo in actionHistoryVo" :key="actionVo.createTime">
          <a-timeline-item :class="getItemColor(actionVo)">
            <p>
              <span class="actionVo-date">{{ actionVo.createTime | dateformat('YYYY-MM-DD') }}</span>
              <span class="actionVo-date note">{{ actionVo.createTime | dateformat(' HH:mm:ss') }}</span>
            </p>
            <span class="actionVo-black agent">{{ actionVo.createName }}</span>
            &nbsp;
            <p class="actionVo-info">{{ $t(actionVo.actionType) }}</p>
            &nbsp;
            <span
              class="actionVo-black agent"
              :title="actionVo.actionContent"
              v-html="
                actionVo.actionContent
                  .replaceAll('disp.nothing', $t('disp.nothing'))
                  .replace('( ', '<span> ( ')
                  .replace(' ) ', ' ) </span>')
              "
            ></span>
          </a-timeline-item>
        </div>
      </a-timeline>
      <a-empty v-else></a-empty>
    </div>
  </a-modal>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction } from '@/api/manage'

export default {
  name: 'ActionHistroy',
  created() {},
  data() {
    return {
      visible: false,
      changePlanId: '',
      title: '变更履歴',
      type: '',
      actionHistoryVo: [],
    }
  },
  methods: {
    open(changePlanId) {
      this.changePlanId = changePlanId
      this.visible = true
      this.historyQuery()
    },
    handleCancel() {
      this.visible = false
    },
    historyQuery() {
      var that = this
      that.actionHistoryVo = []
      getAction('/blaze-sys/k00/k0015/DepartAction/getHistory?changePlanId=' + this.changePlanId, null)
        .then((res) => {
          if (res.success) {
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.actionHistoryVo.push(temp)
            }
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getItemColor(actionVo) {
      if (actionVo.actionType.indexOf('delete') > 0) {
        return 'actionVo-red'
      } else if (actionVo.actionType.indexOf('add') > 0) {
        return 'actionVo-primary'
      } else {
        return 'actionVo-blue'
      }
    },
  },
}
</script>

<style lang="less">
.history-modal-wrapper {
  overflow-y: hidden;

  .ant-modal-content {
    height: 100%;
  }

  .history-wrapper {
    background: rgba(255, 255, 255, 5%);
    border-radius: 4px;
    padding: 10px;
  }

  .actionVo-primary {
    .ant-timeline-item-head {
      color: green !important;
      border-color: green !important;
    }
    .actionVo-info {
      color: green;
    }
  }

  .actionVo-red {
    .ant-timeline-item-head {
      color: #f5222d !important;
      border-color: #f5222d !important;
    }
    .actionVo-info {
      color: #f5222d;
    }
  }

  .actionVo-blue {
    .ant-timeline-item-head {
      color: #1890ff !important;
      border-color: #1890ff !important;
    }
    .actionVo-info {
      color: #1890ff;
    }
  }

  .actionVo-orange {
    .ant-timeline-item-head {
      color: #fa8c16 !important;
      border-color: #fa8c16 !important;
    }
    .actionVo-info {
      color: #fa8c16;
    }
  }

  .actionVo-cyan {
    .ant-timeline-item-head {
      color: #13c2c2 !important;
      border-color: #13c2c2 !important;
    }
    .actionVo-info {
      color: #13c2c2;
    }
  }

  .actionVo-black {
    color: #5d5151;
  }

  .actionVo-date {
    color: var(--color-grey);
  }

  p.actionVo-info {
    display: inline-block;
    border-bottom: 1px dashed;
  }

  span.actionVo-black > span {
    color: var(--color-grey);
    margin-left: 0.5em;
  }
}
</style>
